module.exports = __webpack_public_path__ + "img/bg_02.415818d4.jpg";